'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name fancyBoxBySize
    * @description Initializes a fancybox trigger on a fancybox with information embedded about the size of the popup
    **/

    // Needs only be initialized once per page
    var initialize = function (wrapperEl) {
        let sizeLookup = {
            small: 483,
            medium: 694,
            large: 905 // for hotel popups with image sliders
        };

        let fancyBoxTriggers = wrapperEl.querySelectorAll('[data-fancybox-by-size]');
        let fancyboxesBySize = _.groupBy(fancyBoxTriggers, function (el) {
            return $(el).attr('data-fancybox-by-size');
        })
        for (const [size, fancyBoxEls] of Object.entries(fancyboxesBySize)) {
            let maxWidth = sizeLookup.hasOwnProperty(size) ? sizeLookup[size] : sizeLookup[0];
            let popupOptionsDefaults = {
                padding: [0],
                wrapCSS: 'rounded-popup',
                fitToView: true,
                scrolling: 'no',
                maxWidth: maxWidth,
                autoSize: true,
                autoResize: true,
                tpl: {
                    closeBtn: '<a title="close" class="dialog-close" href="javascript:;"></a>'
                },
                closeClick: false,
                openEffect: 'none',
                closeEffect: 'none',
                afterLoad: function (context, contextAfter) {
                    // This matters when popups have image sliders in them like for hotels
                    var $imageSlider = $(context.href + ' .image-slider');
                    $imageSlider.slick('refresh');
                    var $popupContainer = $(context.href);
                    if ($popupContainer.length > 0 && ($popupContainer.hasClass('ship-popup-container'))) {
                        $popupContainer.find('.nav-tabs li:first-child a').tab('show');
                    }
                }
            };
            if (size === 'large') {
                // Pin hotel popups to the top of the page, so when the images lazy load in and expand the popup, it isn't below the fold as often
                popupOptionsDefaults.topRatio = 0;
            }

            $.each($(fancyBoxEls), function (idx, el) {
                let $this = $(el);
                let wrapperClass = $this.attr('data-fancybox-wrapper-class');
                let popupOptions = {};
                if (wrapperClass && wrapperClass.length > 0) {
                    popupOptions.wrapCSS = 'rounded-popup ' + (wrapperClass ? wrapperClass : '');
                }
                _.defaults(popupOptions, popupOptionsDefaults);

                $this.fancybox(popupOptions);
            });
        }
    };

    // Return an object exposing the public items
    return {
        initialize: initialize
    };
}())